import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-football-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">乐球体育</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              专业体育赛事平台，为体育爱好者提供足球、篮球、综合体育赛事资讯、直播与数据分析。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">赛事分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@leqiusports.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6688</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区体育中心路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 乐球体育 LeQiu Sports. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-white text-lg transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-white text-lg transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-white text-lg transition-colors cursor-pointer" aria-label="抖音">
              <i className="ri-tiktok-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}